// TODO use entries from routes

import { StaticLandingRoutes } from '@webapp/common/resources/landing-routes';

export interface Link {
    name: string;
    path?: string;
    links: Array<Link>;
}

export const menuLinks = [
    {
        name: 'О сервисе',
        path: StaticLandingRoutes.about.path,
    },
    {
        name: 'Возможности',
        links: [
            {
                name: 'Для HR',
                path: StaticLandingRoutes.capabilitiesHr.path,
            },
            {
                name: 'Для маркетинга',
                path: StaticLandingRoutes.capabilitiesMarketing.path,
            },
            {
                name: 'Тесты',
                path: StaticLandingRoutes.capabilitiesTests.path,
            },
            {
                name: 'Голосования',
                path: StaticLandingRoutes.capabilitiesVotes.path,
            },
            {
                name: 'E-mail рассылка',
                path: StaticLandingRoutes.capabilitiesMailing.path,
            },
            {
                name: 'API',
                path: StaticLandingRoutes.capabilitiesApi.path,
            },
        ],
    },
    {
        name: 'Шаблоны',
        path: StaticLandingRoutes.templates.path,
    },
    {
        name: 'Преимущества',
        path: StaticLandingRoutes.advantagesSafety.path,
    },
    {
        name: 'Функционал',
        path: StaticLandingRoutes.functions.path,
    },
    {
        name: 'Панель респондентов',
        path: StaticLandingRoutes.respondentPanel.path,
    },
    {
        name: 'Тарифы',
        links: [
            {
                name: 'Тарифные планы',
                path: StaticLandingRoutes.pricingPlans.path,
            },
            {
                name: 'Порядок подключения',
                path: StaticLandingRoutes.pricingConnectionSteps.path,
            },
            {
                name: 'Способы оплаты',
                path: StaticLandingRoutes.pricingPaymentVariants.path,
            },
        ],
    },
    {
        name: 'Договоры',
        links: [
            {
                name: 'Шаблон договора',
                path: StaticLandingRoutes.docsLicence.path,
            },
            {
                name: 'Политика ПДн',
                path: StaticLandingRoutes.pdPolicy.path,
            },
            {
                name: 'Пользовательское',
                path: StaticLandingRoutes.docsEula.path,
            },
            {
                name: 'Конфиденциальность',
                path: StaticLandingRoutes.docsPrivacyPolicy.path,
            },
            {
                name: 'Оферта',
                path: StaticLandingRoutes.docsPublicOffer.path,
            },
        ],
    },
    {
        name: 'Разработчикам',
        links: [
            {
                name: 'CSS стили',
                path: StaticLandingRoutes.docsCustomCss.path,
            },
            {
                name: 'Документация API',
                path: StaticLandingRoutes.docsPrivateApi.path,
            },
            {
                name: 'Веб-хуки',
                path: StaticLandingRoutes.docsWebHooks.path,
            },
        ],
    },
    {
        name: 'Блог',
        path: StaticLandingRoutes.blog.path,
    },
    {
        name: 'Помощь',
        path: StaticLandingRoutes.help.path,
    },
    {
        name: 'Контакты',
        path: StaticLandingRoutes.contacts.path,
    },
] as Array<Link>;
